import React, { useState } from "react";

interface BrandLogoProps {
  className?: string;
  fallbackText?: string;
  appBrand ?: "auto" | "local" | "vz";
}

type BrandMode = "local" | "vz";

export const resolveAutoBrand = (): BrandMode => {
const appBrand="vz";
 return appBrand;
};

const BrandLogo = ({
  className = "h-8 w-8",
  fallbackText = "L",
  appBrand  = "auto",
}: BrandLogoProps) => {
  const [hasError, setHasError] = useState(false);

  const resolvedBrand = appBrand === "auto" ? resolveAutoBrand() : appBrand;
  const shouldRenderVzLogo = resolvedBrand === "vz";

  if (shouldRenderVzLogo) {
    return (
      <span
        className={`inline-flex flex-shrink-0 items-center justify-center rounded-full border-4 border-gray-900 bg-gray-900 p-2 text-white transition-transform duration-300 dark:border-gray-100 ${className}`}
        aria-hidden="true"
      >
        <img
          src="/verizon.svg"
          alt=""
          className="h-full w-full object-contain"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = "none";
          }}
        />
      </span>
    );
  }

  if (hasError) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full bg-slate-950 font-black leading-none text-red-500 ${className}`}
        aria-hidden="true"
      >
        {fallbackText}
      </span>
    );
  }

  return (
    <img
      src="/logo1.png"
      alt=""
      aria-hidden="true"
      className={`object-contain rounded-full bg-white/90 dark:bg-slate-100/95 p-0.5 ring-1 ring-slate-300 dark:ring-slate-600 shadow-sm drop-shadow-[0_1px_2px_rgba(15,23,42,0.35)] ${className}`}
      onError={() => setHasError(true)}
    />
  );
};

export default BrandLogo;
